<template>
	<div class="dashboard" @dragover.prevent @drop.prevent>
		<MeetingCard
			v-if="recorderStore.state === 'recording' && meeting"
			:meeting="meeting"
			:started-at="recorderStore.startedAt"
			@stop="recorderStore.stop"
		/>

		<TheTopbar key="topbar" />
		<div key="routerview" class="flex grow overflow-hidden">
			<RouterView class="grow" />
		</div>
		<Toaster rich-colors position="top-center" />
	</div>
</template>

<script lang="ts" setup>
import { markRaw } from "vue";
import { useMainStore } from "@/store/useMainStore";
import RowText from "@/components/input-formvuelate/RowText.vue";
import RowSelect from "@/components/input-formvuelate/RowSelect.vue";
import RowOption from "@/components/input-formvuelate/RowOption.vue";
import SchemaHeading from "@/components/SchemaHeading.vue";
import { SchemaForm } from "formvuelate";
import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";
import { useRecorderStore } from "@/store/useRecorderStore";
import { useQuery } from "@/composables/useZero";
import { queries } from "@loanlink-nl/zero";

markRaw(RowText);
markRaw(RowSelect);
markRaw(RowOption);
markRaw(SchemaForm);
markRaw(SchemaHeading);

const recorderStore = useRecorderStore();
const store = useMainStore();

const { data: meeting } = useQuery(() =>
	queries.conversations.byId({
		agencyId: store.agency?.id ?? "",
		idField: "id",
		id: recorderStore.meetingId,
	}),
);
</script>

<style lang="scss">
#app {
	position: relative;

	.alert-box {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		padding: 50px;
		background: var(--background-primary);
		border-radius: var(--border-radius);
		max-width: 400px;
		display: flex;
		flex-direction: column;
		row-gap: 16px;
		align-items: flex-start;
		border: 1px solid var(--border);

		button {
			cursor: pointer;

			&:disabled {
				cursor: default;
				pointer-events: none;
			}
		}
	}
}

.dashboard {
	/* display: grid; */
	/* grid-template-rows: auto 1fr; */
	display: flex;
	flex-direction: column;
	width: 100%;

	.main-content {
		display: grid;
		grid-template-columns: 16rem 1fr;
		overflow: hidden;

		@media screen and (max-width: var(--mobile-size)) {
			display: flex;
			flex-direction: column;
			overflow: visible;
		}
	}

	&.blur {
		filter: blur(4px);
		pointer-events: none;
	}
}

.dark-overlay {
	width: 100%;
	height: 100%;
	position: absolute;
	background: rgba(0, 0, 0, 0.3);
	z-index: 1000;
}

.v-move,
.v-enter-active,
.v-leave-active {
	transition:
		transform 0.3s ease,
		opacity 0.3s ease;
	transform: translateY(0);
	/* visible state */
}

.v-enter-from,
.v-leave-to {
	transform: translateY(-100%);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.v-leave-active {
	position: absolute;
}
</style>
